/* src/app/shared/checklist-modal/components/slide-control-bar/slide-control-bar.component.scss */
.bar {
  background-color: var(--ion-color-primary);
  height: calc(3rem + env(safe-area-inset-bottom));
}
.text {
  position: relative;
  top: 8px;
  color: var(--ion-color-primary-contrast);
  font-size: 18px;
}
.arrow {
  height: 40px;
  font-size: 40px;
  color: var(--ion-color-medium-tint);
}
.active {
  color: var(--ion-color-primary-contrast);
}
/*# sourceMappingURL=slide-control-bar.component.css.map */
